module.exports = __webpack_public_path__ + "img/gradient-map_jp.926e4d8.jpg";